module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "episode"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    })
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.title)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "meta"
  }, [(_vm.episode.number) ? _c('span', [_vm._v(_vm._s(_vm.episodeNumber) + " •")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formattedDate))]), _vm._v(" "), (_vm.episodeTopics) ? _c('span', [_vm._v("• \n        "), _vm._l((_vm.episodeTopics), function(topic, index) {
    return _c('span', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Category',
          params: {
            topic: topic.slug
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(topic.name)
      }
    }), (index + 1 !== _vm.episodeTopics.length) ? _c('span', [_vm._v(", ")]) : _vm._e()], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.excerpt)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "more-link",
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [_vm._v("More")])], 1), _vm._v(" "), (_vm.index === 6) ? _c('v-waypoint', {
    on: {
      "waypoint": _vm.$parent.handleScroll
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a363cac8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/episodes/Episode.vue
// module id = 800
// module chunks = 1